import React from 'react';
import RecentPilgrimages from '../components/RecentPilgrimages';
import Testimonials from '../components/Testimonials';
import ContactUs from '../components/ContactUs';
import Newsletter from '../components/Newsletter';
import PilgrimageMoments from '../components/PilgrimageMoments';
import { useI18n } from '../i18n/LanguageContext';

const HERO_IMAGE = `${process.env.PUBLIC_URL}/assets/home.jpeg`;
const COMMUNITY = `${process.env.PUBLIC_URL}/assets/community`;

export default function Home() {
  const { t } = useI18n();
  return (
    <>
      <section id="home" className="hero hero--portrait">
        {/* Blurred copy of the portrait tints the whole hero in her blue. */}
        <div
          className="hero-backdrop"
          style={{ backgroundImage: `url(${HERO_IMAGE})` }}
          aria-hidden="true"
        />
        <div className="hero-inner">
          <div className="hero-copy">
            <span className="hero-eyebrow">{t('hero.eyebrow')}</span>
            <h1 className="hero-title">{t('hero.title')}</h1>
            <p className="hero-subtitle">{t('hero.subtitle')}</p>
            <a className="hero-cta" href="#pilgrimages">{t('hero.cta')}</a>
          </div>
          <figure className="hero-portrait">
            <img src={HERO_IMAGE} alt={t('hero.image_alt')} />
          </figure>
        </div>
      </section>

      <section id="about" className="about">
        <div className="about-grid">
          <div className="about-media">
            <blockquote className="about-quote">
              <p>
                Muri iyo minsi, 26 umumalayika wa Nyagasani abwira Filipo ati
                « Haguruka ugende werekeje mu majyepfo, unyuremu nuhanda umanuka
                i Yeruzalemu ujya i Gaza, ubu nguhu ukaba utarimo abagenzi. »
                <span className="about-quote-ref"> 27Filipo ahera ko aragenda</span>
              </p>
            </blockquote>

            <div className="about-photos">
              <div
                className="about-photo about-photo--back"
                role="img"
                aria-label={t('about.photo_back_alt')}
                style={{ backgroundImage: `url(${COMMUNITY}/procession-in-white.jpg)`, backgroundPosition: 'center 35%' }}
              />
              <div
                className="about-photo about-photo--front"
                role="img"
                aria-label={t('about.photo_front_alt')}
                style={{ backgroundImage: `url(${COMMUNITY}/candles-with-priest.jpg)`, backgroundPosition: '40% center' }}
              />
            </div>
          </div>

          <div className="about-text">
            <div className="about-eyebrow">
              <span className="about-dot" /> {t('about.eyebrow')}
            </div>
            <h2 className="about-heading">{t('about.title')}</h2>
            <p>{t('about.intro')}</p>
            <h3 className="about-subheading">{t('about.welcome')}</h3>
            <p>{t('about.mission')}</p>


            <blockquote className="about-quote about-quote--inline">
              <p>
                Muri iyo minsi, 26 umumalayika wa Nyagasani abwira Filipo ati
                « Haguruka ugende werekeje mu majyepfo, unyuremu nuhanda umanuka
                i Yeruzalemu ujya i Gaza, ubu nguhu ukaba utarimo abagenzi. »
                <span className="about-quote-ref"> 27Filipo ahera ko aragenda</span>
              </p>
            </blockquote>
          </div>
        </div>
      </section>

      <RecentPilgrimages />
      <PilgrimageMoments />
      <Testimonials />
      <ContactUs />
      <Newsletter />
    </>
  );
}
